import { Component, OnInit,Input, Output,EventEmitter,ChangeDetectorRef } from '@angular/core';
import{SubjectManagmentService} from '../../../Services/subject-management/subject-management.service';
//import { SortablejsOptions } from 'angular-sortablejs';
 import {CdkDragDrop,moveItemInArray} from '@angular/cdk/drag-drop';
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-subject-display-order',
  templateUrl: './subject-display-order.component.html',
  styleUrls: ['./subject-display-order.component.css']
})
export class SubjectDisplayOrderComponent implements OnInit {
 @Input() SDOInput:any;
 @Output() cancelSubjectOrderChange:EventEmitter<any> =new EventEmitter<any>();
 @Output() onSubjectOrderChangeSucces:EventEmitter<any> =new EventEmitter<any>();
 @Output() closeAddEditElement:EventEmitter<any> =new EventEmitter<any>();

 

 sortParam = 'Display_Order';
  constructor(private cdr: ChangeDetectorRef,public service:SubjectManagmentService,public toast:ToastrService) {}

  ngOnInit() {
    if(Number(this.SDOInput.Parent_Subject_Id)>0){
      this.getsubject(this.SDOInput.Parent_Subject_Id);  
      this.getBreadcrumbDetails(this.SDOInput.Parent_Subject_Id);
    }
    //this.cdr.detectChanges();
  }

  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }


  Savebutton:boolean=false;


  getData(data:string){
    this.Savebutton=true;
  }



  Breadcrumblist:any;
  getBreadcrumbDetails(data:any){
    this.service.getBreadcrumbDetails({'ID':data}).subscribe((i:any)=>{
      this.Breadcrumblist=i;
    }, (error:any) => { console.log(error) }
    );
  }

  cancel(){
    this.cancelSubjectOrderChange.emit(true);
  }

  subject:any;
  getsubject(ID:Number){
    let list: any = {};
    list["currentNodeID"] = ID;
    list["screenName"] = 'SUBJECT BREAKDOWN';
    list["childRecordStatus"] = 'ALL';
    this.service.getSubjectTree(list).subscribe((i:any)=>{
      this.subject=i;
    }, (error:any) => { console.log(error) }
    );
  }

  onDrop(event:CdkDragDrop<any>){
    this.getData('test');
    moveItemInArray(
      event.container.data,
      event.previousIndex,
      event.currentIndex
    )
  }



  //#region order drag and drop
//   isdraggable: boolean = true;
//   draggableOptions: SortablejsOptions = {
//     draggable: '.draggable',
//     animation: 150
// };

// isDraggable() {
//     this.isdraggable = !this.isdraggable;
// }
@Output() getsubjectDataRefresh:EventEmitter<any> =new EventEmitter<any>();
Reload:boolean=true;
updateReorder() {
  let dataOrder = [];
  for (let i = 0; i < this.subject.length; i++) {
      let count:number = i;
      dataOrder.push({ Subject_ID: this.subject[i].ID, DisplayOrder: Number(count + 1) })
  }
  this.service.DisplayOrderChange({SubjectOrder:dataOrder,LoggedInUser:""}).subscribe((i:any)=> {this.toast.success(i.Message);
    this.onSubjectOrderChangeSucces.emit(true);
    this.cancelSubjectOrderChange.emit(true);
    this.closeAddEditElement.emit(true);
//       } ).catch((e:any)=> 
//     {this.toast.warning(e.Message);
      
//     this.onSubjectOrderChangeSucces.emit(true);
//       });
}, (error:any) => { 
  this.toast.warning(error.Message);
  this.onSubjectOrderChangeSucces.emit(true);
  console.log(error)
 }
);
}


 

}
